import React from "react";
import PropTypes from "prop-types";

const Strong = ({ title, className }) => {
  return <strong className={className}>{title}</strong>;
};

Strong.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};

export default Strong;
